<template>
    <!-- Modal -->
    <div class="modal fade" id="vmbc" role="dialog">
        <div class="modal-dialog">

        <!-- Modal content-->
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">Add new product</h4>
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>

            <div class="modal-body">
                <div align="panel panel-default mb-4">
                    <div class="panel-heading" align="center">
                        <span class="text-danger" v-if="submitStatus === 'ERROR'">Please fill the form correctly.</span>
                    </div>
                </div>


                <div class="form-group" :class="{ 'form-group--error': $v.add.product.$error }">
                    <input class="form-control" v-model.trim="$v.add.product.$model" placeholder="Product Name"/>
                    <div align="center" v-if="!$v.add.product.required"> <small class="text-danger" v-if="submitStatus === 'ERROR'">Name is required</small></div>
                </div>

                <div class="form-group" >


                    <model-select :options="categories"
                        v-model="category"
                        placeholder="Please select categories">
                    </model-select>

                </div>

                <div class="form-group" :class="{ 'form-group--error': $v.add.xero.$error }">
                    <input class="form-control" v-model.trim="$v.add.xero.$model" placeholder="Xero"/>
                    <div align="center" v-if="!$v.add.xero.required"> <small class="text-danger" v-if="submitStatus === 'ERROR'">Xero is required</small></div>
                </div>

                <div class="form-group">
                    <textarea v-model="description" rows="5" class="form-control mt-1" placeholder="Product Description"></textarea>
                </div>

                    <p class="text-success" v-if="submitStatus === 'OK'">Product added successfully</p>

                    <p class="text-warning" v-if="submitStatus === 'PENDING'">Sending...</p>

                </div>

            <div class="modal-footer">
                <button type="button" class="btn btn-success" @click="addProduct"><i class="fa fa-save"></i></button>
                <button type="button" class="btn btn-default" data-dismiss="modal"><i class="fa fa-times"></i></button>
            </div>
        </div>

        </div>
    </div>
</template>
<script>
import { required, minLength } from 'vuelidate/lib/validators'
import { ModelSelect } from 'vue-search-select'
export default {
    components: {
        ModelSelect
    },
    props: ['categories'],
    validations: {
        add:{
            product: {
                required
            },
            xero: {
                required
            }
        },
    },
    data() {
        return {
            submitStatus: null,
            category: {
                value: '',
                text: ''
            },
            add: {
                product: '',
                category:'',
                xero:'',
            },
            description: ''
        }
    },
    methods: {
        addProduct() {

            this.$v.$touch()
            if (this.$v.$invalid) {
                this.submitStatus = 'ERROR'
                    setTimeout(() => {
                    this.submitStatus = null
                    }, 2000)
            } else {
                // do your submit logic here
                this.submitStatus = 'PENDING'
                setTimeout(() => {
                this.submitStatus = 'OK'
                    setTimeout(() => {
                        axios.
                        post('./api/Product/Add', {
                            product: this.add.product,
                            cateogry: this.category.value,
                            xero: this.add.xero,
                            description: this.description,
                            user_id: this.$root.id,
                            name: this.$root.staffname,
                        })
                        .then(response =>
                            console.log(response),
                        );
                        this.$parent.getProducts()
                    this.add.product = ''
                    this.add.category = ''
                    this.add.xero = ''
                    this.submitStatus = null
                    }, 500)
                }, 500)
            }
        },
    }
}
</script>



// WEBPACK FOOTER //
// resources/js/Item/Product/ProductAdd.vue